import React from 'react'
import FormSF from '../../../widgets/form/FormSF'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import InputCheckBoxUI from '../../../widgets/form/InputCheckBoxUI'
import './DailyRepayment.css'

const DailyRepaymentUI = ({context, checked, onSubmit, submitted, successMsg, errorList}) =>
  <FormSF context={context} successMsg={successMsg} errorList={errorList} className='c_daily_r'>
    <div className='g_flex_h g_flex_left g_flex_top'>
      <SpinnerUI show={submitted} reserveSpace={true} />
      <InputCheckBoxUI label='Enable daily repayment (test accounts only)'
        onChange={onSubmit} checked={checked}
        name='daily'
      />
    </div>
  </FormSF>

export default DailyRepaymentUI
